/**
 * Server-controlled feature switches, injected by dashboard.blade.php as window.pl_features.
 * Fails closed: a missing global or key means the feature is off.
 */
export const isFeatureEnabled = (name) => window.pl_features?.[name] === true

// Virtual Influencer UI (PD-4742), hidden unless VIRTUAL_INFLUENCERS_UI_ENABLED (SRR-2981).
export const viUiEnabled = () => isFeatureEnabled('virtual_influencers')
